import { useState } from "react";
import { CircleAlert } from "lucide-react";
import Modal from "./Modal";

const MIN_PASSWORD_LENGTH = 8;

export default function PasswordFormModal({ user, busy = false, error = "", onSubmit, onClose }) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [localError, setLocalError] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    setLocalError("");

    if (password.length < MIN_PASSWORD_LENGTH) {
      setLocalError(`رمز عبور باید حداقل ${MIN_PASSWORD_LENGTH} کاراکتر باشد.`);
      return;
    }
    if (password !== confirm) {
      setLocalError("رمز عبور و تکرار آن یکسان نیستند.");
      return;
    }
    onSubmit({ new_password: password });
  };

  const shownError = localError || error;

  return (
    <Modal
      title={`تغییر رمز عبور «${user.username}»`}
      description="رمز جدید بلافاصله جایگزین رمز فعلی این کاربر می‌شود."
      onClose={onClose}
      footer={
        <>
          <button type="submit" form="password-form" className="btn btn-primary" disabled={busy}>
            {busy ? "در حال ذخیره…" : "ذخیره رمز"}
          </button>
          <button type="button" className="btn btn-ghost" onClick={onClose} disabled={busy}>
            انصراف
          </button>
        </>
      }
    >
      {shownError && (
        <div className="alert alert-error">
          <CircleAlert size={17} strokeWidth={2} aria-hidden="true" />
          {shownError}
        </div>
      )}

      <form id="password-form" onSubmit={handleSubmit} noValidate>
        <div className="field">
          <label htmlFor="new-user-password">رمز عبور جدید</label>
          <input
            id="new-user-password"
            type="password"
            className="ltr-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
          />
          <span className="hint">حداقل {MIN_PASSWORD_LENGTH} کاراکتر.</span>
        </div>

        <div className="field">
          <label htmlFor="confirm-user-password">تکرار رمز عبور جدید</label>
          <input
            id="confirm-user-password"
            type="password"
            className="ltr-input"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            autoComplete="new-password"
          />
        </div>
      </form>
    </Modal>
  );
}
